export class AnnotationEvent {

}
